import React from "react";
import { Dialog, withStyles } from "@material-ui/core";
import "../../styles/sharedStyles.scss";
import Grid from "@material-ui/core/Grid";
import Clear from "@material-ui/icons/Clear";
import setupIncompleteDialogStyles from "./SetupIncompleteDialog.module.scss";
import Button from "@material-ui/core/Button";
import { withTranslation } from "react-i18next";

// This class will be used when Business wants to enable Setup Incomplete Dialog

const StyledClear = withStyles({
  root: {
    width: 27,
    height: 27,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

const StyledDialog = withStyles({
  paper: {
    width: 700,
    maxWidth: 700,
  },
})(Dialog);

const StyledGrid = withStyles({
  root: {
    width: 700,
    maxWidth: 700,
  },
  container: {
    width: 700,
    maxWidth: 700,
  },
})(Grid);

class SetupIncompleteDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <StyledDialog
        open={this.props.open}
        className={setupIncompleteDialogStyles.dialog}
        onClose={this.props.onClose}
      >
        <StyledGrid
          container
          data-testid="cancelOrderDialog"
          className={setupIncompleteDialogStyles.dialogContainer}
          justify="center"
        >
          <Grid item md={12} className={setupIncompleteDialogStyles.cancel}>
            <div>
              <button data-testid="closeDialog" onClick={this.props.onClose}>
                <StyledClear />
              </button>
            </div>
          </Grid>

          <Grid item md={9}>
            <span className={setupIncompleteDialogStyles.dialogTitle}>
              <span
                className={setupIncompleteDialogStyles.warningOrange}
              ></span>
              <span
                className={
                  setupIncompleteDialogStyles.setupIncompleteDialogTitle
                }
              >
                {this.props.dialogProps.title}
              </span>
            </span>
          </Grid>

          <Grid item md={9}>
            <div className={setupIncompleteDialogStyles.dialogDescription}>
              {this.props.dialogProps.body}
            </div>
          </Grid>

          <Grid item md={9}>
            {this.props.pendingActionNamesList &&
            this.props.pendingActionNamesList.length > 0 ? (
              <div className={setupIncompleteDialogStyles.setupIncompleteBody}>
                <ul className={setupIncompleteDialogStyles.dashed}>
                  {this.props.pendingActionNamesList.map((item, index) => (
                    <li key={index}>
                      {this.props.t("DealerPendingActionsDescription." + item)}
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </Grid>

          <Grid item md={9}>
            <div className={setupIncompleteDialogStyles.dealerSetupConfirm}>
              <Button
                className={setupIncompleteDialogStyles.setUpMembership}
                name="close"
                data-testid="closeTestId"
                onClick={this.props.onClose}
              >
                {this.props.dialogProps.close}
              </Button>
            </div>
          </Grid>
        </StyledGrid>
      </StyledDialog>
    );
  }
}

export default withTranslation("emp")(SetupIncompleteDialog);
